import * as React from 'react';
import Box from '../layoutComponents/Box';

/**
 * Container for modal body.
 */
const Body: React.FC<{ children?: React.ReactNode }> = props => <Box p={4}>{props.children}</Box>;

export default Body;
